import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleResourceManager } from "../hooks/roles/ProtectedRoleResourceManager";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const Guardias = React.lazy(() => import("../screean/task/guardias"));
export function guardias() {
  return (
    <Route
      path="/guardias"
      element={
        <LazySuspense>
          {" "}
          <ProtectedRoute>
            <ProtectedRoleResourceManager>
              <LazySuspense>
                <Guardias />
              </LazySuspense>
            </ProtectedRoleResourceManager>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
